import { render, staticRenderFns } from "./create_eod.vue?vue&type=template&id=5b60dd90&scoped=true&"
import script from "./create_eod.vue?vue&type=script&lang=js&"
export * from "./create_eod.vue?vue&type=script&lang=js&"
import style0 from "./create_eod.vue?vue&type=style&index=0&id=5b60dd90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b60dd90",
  null
  
)

export default component.exports